import styled from 'styled-components';
import { Button, Icons } from '@cyberint/dsc';

export const Link = styled.a`
  color: var(--midnightGreen);
  text-decoration: underline;
  font-weight: 500;
`;

export const LinkedButton = styled(Button.Linked)`
  display: inline;
  padding: 0;
  height: unset;

  .dsc-button-title {
    font-weight: 500;
    padding: 0;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  background-color: var(--palePurple);
`;

export const Icon = styled(Icons.GraduationCap).attrs({ size: 32, color: 'var(--indigo)' })``;
